/**
 * Frontera de error global: si algo falla fuera de las pantallas (el
 * router maneja los errores de cada ruta), muestra un mensaje con opción de
 * recargar en lugar de una página en blanco, y reporta el error.
 */
import { Component, type ReactNode } from 'react'
import { reportClientError } from '@/lib/monitoring'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  failed: boolean
}

/** Atrapa errores de render de toda la aplicación y los reporta. */
export class AppErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true }
  }

  override componentDidCatch(error: Error): void {
    void reportClientError(error)
  }

  override render() {
    if (!this.state.failed) return this.props.children
    return (
      <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-bold">Algo salió mal</h1>
        <p className="max-w-sm text-sm text-muted-foreground">La aplicación encontró un error inesperado. Ya lo registramos; recargue para continuar.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Recargar
        </button>
      </div>
    )
  }
}
